import React from 'react'
import ReactDOM from 'react-dom'
import './styles/main.scss'
import App from './App'
import 'semantic-ui-css/semantic.min.css'
import 'mapbox-gl/dist/mapbox-gl.css'

ReactDOM.render(<App/>, document.getElementById('root'))